<template>
  <basic-container id="carmonthlog20220108">
    <avue-crud
      :option="option"
      :table-loading="loading"
      v-if="reWrite"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.createTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.createTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthlog_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="operateContent" slot-scope="scope">
        <wq-overHidden :content="scope.row.operateContent">
          <span>{{ scope.row.operateContent }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/carv2/carmonthlog';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      reWrite: false,
      spaceList: [],
      form: {},
      query: {},
      loading: true,
      tempSpaceName: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      firstDisplayFlag: false,
      option: {
        height: 'auto',
        calcHeight: 50,
        searchShow: true,
        searchMenuSpan: 6,
        tip: true,
        border: true,
        index: true,
        indexLabel: '#',
        viewBtn: true,
        selection: true,
        menuWidth: 100,
        menu: false,
        columnBtn: true,
        refreshBtn: true,
        stripe: true,
        selectionClearBtn: true,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceName',
            search: true,
            clearable: false,
            props: {
              label: 'title',
              value: 'title',
            },
            width: 120,
          },
          {
            label: '车主姓名',
            prop: 'customerName',
            search: true,
            width: 90,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            search: true,
            width: 80,
          },
          {
            label: '操作类型',
            prop: 'operateType',
            type: 'select',
            dataType: 'number',
            search: true,
            width: 160,
            dicData: [
              {
                label: '月卡车审核',
                value: 1,
              },
              {
                label: '新增月卡车',
                value: 2,
              },
              {
                label: '修改月卡车',
                value: 6,
              },
              {
                label: '月卡车退费',
                value: 4,
              },
              {
                label: '变更车牌',
                value: 3,
              },
              {
                label: '删除过期车辆',
                value: 7,
              },
              {
                label: '月卡车信息已同步至岗亭',
                value: 8,
              },
              {
                label: '补缴月卡车更新临停记录',
                value: 9,
              },
              {
                label: '操作黑名单',
                value: 13,
              },
              {
                label: '操作白名单',
                value: 14,
              },
              {
                label: '新增储值车',
                value: 17,
              },
              {
                label: '编辑储值车',
                value: 18,
              },
              {
                label: '删除储值车',
                value: 19,
              },
              {
                label: '储值车车牌变更',
                value: 20,
              },
            ],
          },
          {
            label: '操作人',
            prop: 'remark3',
            width: 100,
          },
          {
            label: '操作时间',
            prop: 'createTime',
            width: 150,
          },
          {
            label: '操作日期',
            prop: 'dateRange',
            search: true,
            searchRange: true,
            hide: true,
            searchSpan: 12,
            searchslot:true,
            showColumn: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            width: 150,
          },
          {
            label: '操作内容',
            prop: 'operateContent',
            type: 'textarea',
            slot: true,
            span: 24,
          },
          {
            label: '车主手机',
            prop: 'customerPhone',
            search: true,
            width: 120,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthlog_add, false),
        viewBtn: this.vaildData(this.permission.carmonthlog_view, false),
        delBtn: this.vaildData(this.permission.carmonthlog_delete, false),
        editBtn: this.vaildData(this.permission.carmonthlog_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 410;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        const column = this.findObject(this.option.column, 'spaceName');
        column.dicData = data.data;
        column.searchValue = this.spaceList[0].title;
        this.query.spaceName = this.spaceList[0].title;
        this.tempSpaceName = this.spaceList[0].title;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 410) {
              this.option.height = this.bodyHeight - 300;
            } else {
              this.option.height = this.bodyHeight - 410;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.customerName =''
      this.query.carNo=''
     
      this.query.operateType=''
      this.query.customerPhone=''
      this.query.createTimeStart=''
      this.query.createTimeEnd=''
      this.query.spaceName=''
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.customerName =params.customerName
      this.query.carNo=params.carNo
     
      this.query.operateType=params.operateType
      this.query.customerPhone=params.customerPhone
      this.query.spaceName=params.spaceName
      // if( this.vdui.isEmpty(this.query.createTimeStart)||this.vdui.isEmpty(this.query.createTimeEnd)){
      //   console.log("****")
      //   this.query.createTimeStart=''
      //   this.query.createTimeEnd=''
      // }
      // this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      // if (this.query.dateRange) {
      //   this.query.createTimeStart = this.query.dateRange[0];
      //   this.query.createTimeEnd = this.query.dateRange[1];
      // }
      //如果加载列表时spaceName为空，则将spaceName置为当前的第一个车场
      if (this.query.spaceName == undefined || this.query.spaceName == '') {
        this.query.spaceName = this.tempSpaceName;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.spaceName = this.spaceList[0].title;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss">
#carmonthlog20220108 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
